import { getLocationData } from "./helper-methods";

// Function to detect the user's current country
export const detectUserCountry = async (): Promise<string | null> => {
  try {
    const locationData = await getLocationData();
    return locationData.country || null;
  } catch (error) {
    console.error("Error detecting user country:", error);
    return null;
  }
};
